import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Modal,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { RxCross1 } from "react-icons/rx";
import {
  fetchCategoriesProduct,
  getLabelPurchase,
  getPrincipalPbf,
} from "../../../../services/purchaseApi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalFilter = ({ open, setOpen, reqBody, setReqBody }) => {
  const [isPrincipal, setIsPrincipal] = useState(false);
  const [tempPrincipalArr, setTempPrincipalArr] = useState([]);
  const [tempLabelArr, setTempLabelArr] = useState([]);

  const handleClose = () => {
    setTempPrincipalArr([]);
    setTempLabelArr([]);
    setOpen(false);
  };

  const { data: dataPrincipal, isFetching: isFetchingPrincipal } = useQuery({
    queryKey: ["rank-principle", open],
    queryFn: () => getPrincipalPbf(),
    enabled: open === true,
    refetchOnWindowFocus: false,
  });

  const { data: dataLabel, isFetching: isFetchingLabel } = useQuery({
    queryKey: ["label-list", open],
    queryFn: () => getLabelPurchase(1, 100, ""),
    enabled: open === true,
  });

  useEffect(() => {
    if (open) {
      setTempPrincipalArr(reqBody.principal_ids);
      setTempLabelArr(reqBody.label_ids);
    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px]">Filter</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>
          <div className="flex justify-between items-center px-8 py-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="text-[16px] flex md:block items-center gap-4 md:border-r-2 w-full pr-4">
                <p
                  className={`${
                    isPrincipal ? "text-gray-300" : ""
                  } md:mb-3 cursor-pointer hover:text-gray-500`}
                  onClick={() => setIsPrincipal(false)}
                >
                  Golongan
                </p>
                <p
                  className={`${
                    isPrincipal ? "" : "text-gray-300"
                  } cursor-pointer hover:text-gray-500`}
                  onClick={() => setIsPrincipal(true)}
                >
                  Principal
                </p>
              </div>
              <div className="w-full overflow-y-auto overflow-x-hidden max-h-[40vh] md:col-span-3">
                {isPrincipal ? (
                  <div>
                    {dataPrincipal && !isFetchingPrincipal ? (
                      <div className="w-full">
                        {dataPrincipal.map((item, i) => (
                          <FormControlLabel
                            sx={{ width: "100%", marginBottom: 1 }}
                            control={<Checkbox value={item.principal_id} />}
                            label={item.principal_name_alias}
                            checked={tempPrincipalArr.includes(item.principal_id)}
                            onChange={() => {
                              const index = tempPrincipalArr.findIndex(
                                (id) => id === item.principal_id
                              );

                              setTempPrincipalArr(
                                index < 0
                                  ? [...tempPrincipalArr, item.principal_id]
                                  : [
                                      ...tempPrincipalArr.slice(0, index),
                                      ...tempPrincipalArr.slice(index + 1),
                                    ]
                              );
                            }}
                          />
                        ))}
                      </div>
                    ) : (
                      <CircularProgress size={20} />
                    )}
                  </div>
                ) : (
                  <div>
                    {dataLabel && !isFetchingLabel ? (
                      <div className="w-full">
                        {dataLabel.map((item, i) => (
                          <FormControlLabel
                            sx={{ width: "100%", marginBottom: 1 }}
                            control={<Checkbox value={item.id} />}
                            label={item.label_name}
                            checked={tempLabelArr.includes(item.id)}
                            onChange={() => {
                              const index = tempLabelArr.findIndex(
                                (id) => id === item.id
                              );

                              setTempLabelArr(
                                index < 0
                                  ? [...tempLabelArr, item.id]
                                  : [
                                      ...tempLabelArr.slice(0, index),
                                      ...tempLabelArr.slice(index + 1),
                                    ]
                              );
                            }}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="w-full">
                        <CircularProgress size={20} />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-end items-center px-8 py-4 gap-2">
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#F1FAF0] text-[#6F955B] border-[#6F955B] hover:bg-gray-300"
              onClick={handleClose}
            >
              Batal
            </button>
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#6F955B] border-[#6F955B] text-white hover:bg-gray-300"
              onClick={() => {
                setReqBody((prevVal) => ({
                  ...prevVal,
                  label_ids: tempLabelArr,
                  principal_ids: tempPrincipalArr,
                  offset: 1,
                }));
                handleClose();
              }}
            >
              Simpan
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalFilter;
